import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    padding: '35px 15px',
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    padding: '5px 0 10px'
  },
  btnClose: {
    marginTop: 15,
    fontSize: 14,
    fontWeight: 'bold'
  },
  tableCellItem: {
    borderBottom: '2px solid #E0E0E0',
    borderTop: '2px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    fontSize: 14,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '2px solid #E0E0E0',
    borderTop: '2px solid #E0E0E0',
    fontSize: 14
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({ classes, updateOpenDetailModal, settingMenuDetail }) => {
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleDetail}>
          無料メニュー設定 詳細
        </Typography>
        <div>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニューID
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {settingMenuDetail.menuId}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニュー名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {settingMenuDetail.menuName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  税込価格
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {settingMenuDetail.includedTaxPrice}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  無料提供
                  <br />
                  開始日〜終了日
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  <span>{settingMenuDetail.gochiKidFreeStartDate}</span>
                  <span>〜</span>
                  <span>{settingMenuDetail.gochiKidFreeEndDate}</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  食数（無料提供総数）
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {settingMenuDetail.gochiKidFreeSet}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              updateOpenDetailModal(false);
            }}
            className={classes.btnClose}
          >
            閉じる
          </Button>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
